export default {
  postCheck: (state) => {
    return state.postCheck;
  },

  userId: (state) => {
    return state.userId;
  },

  requestsCount: (state) => {
    return state.requestsCount;
  },

  loginCheck: (state) => {
    return state.loginCheck;
  },
  checkCode: (state) => {
    return state.checkCode;
  },

  loadingBtn: state => {
    return state.loadingBtn;
  },

  deviceRegistrationToken: (state) => {
    return state.deviceRegistrationToken;
  },

};
